module.exports = __webpack_public_path__ + "static/unilever-1bd58733d8d7cdae87fc1aec280fb1c6.svg";